import Select from 'react-select';

import {retailerT} from '@/lib/types/retailer.types';
import {BasicRetailerT} from '@/lib/types/user.types';

type RetailerSelectorProps = {
  retailers: BasicRetailerT[] | retailerT[];
  selectedRetailer: BasicRetailerT | retailerT | null;
  setSelectedRetailer: (retailer: BasicRetailerT | retailerT | null) => void;
};

const RetailerSelector = ({retailers, selectedRetailer, setSelectedRetailer}: RetailerSelectorProps) => {
  return (
    <div className="w-full">
      <label htmlFor="retailer-selector">Retailer</label>
      {retailers.length <= 1 ? (
        <div className="rounded-lg bg-[#1a1a1a] p-2 text-white">
          {retailers[0]?.retailer_name || 'No retailers available'}
        </div>
      ) : (
        <Select
          options={retailers.map(retailer => ({
            label: retailer.retailer_name,
            value: retailer.retailer_id,
          }))}
          value={
            selectedRetailer
              ? {
                  label: selectedRetailer.retailer_name,
                  value: selectedRetailer.retailer_id,
                }
              : null
          }
          onChange={option => setSelectedRetailer(retailers.find(r => r.retailer_id === option?.value) ?? null)}
          styles={{
            control: (styles, state) => ({
              ...styles,
              borderColor: state.isFocused ? '#007bff' : styles.borderColor,
              background: '#1a1a1a',
              color: '#fff',
              borderRadius: '0.5rem',
              padding: '0.5rem',
            }),
            menu: styles => ({
              ...styles,
              background: '#1a1a1a',
            }),
            option: (styles, {isFocused, isSelected}) => ({
              ...styles,
              background: isFocused ? '#2a2a2a' : isSelected ? '#1a1a1a' : '#1a1a1a',
              color: '#fff',
              ':active': {
                backgroundColor: '#2a2a2a',
              },
            }),
            singleValue: styles => ({
              ...styles,
              color: '#fff',
            }),
          }}
        />
      )}
    </div>
  );
};

export default RetailerSelector;
